// Zoom level CSS class constants
export const ZOOM_LEVEL_CLASSES = {
  LOWER_THAN_0_3: 'zoom-level-lower-than-0_3',
  HIGHER_THAN_0_3: 'zoom-level-higher-than-0_3',
  LOWER_THAN_0_35: 'zoom-level-lower-than-0_35',
  HIGHER_THAN_0_35: 'zoom-level-higher-than-0_35',
  LOWER_THAN_0_4: 'zoom-level-lower-than-0_4',
  HIGHER_THAN_0_4: 'zoom-level-higher-than-0_4',
  LOWER_THAN_0_75: 'zoom-level-lower-than-0_75',
  HIGHER_THAN_0_75: 'zoom-level-higher-than-0_75',
} as const;
